import PropTypes from 'prop-types'

import InputBase from './InputBase'
import Wrapper from './Wrapper'

import './textArea.scss'

export default class TextArea extends InputBase {
  constructor(props) {
    super(props)
    this.setInitialState(props)
    this.onFormElementChange = this.onFormElementChange.bind(this)
  }

  render() {
    const {wrap, ...otherProps} = this.props

    if (wrap) {
      return (
        <Wrapper {...otherProps} errors={this.errors()}>
          <InputElement {...otherProps} onChange={this.onFormElementChange} />
        </Wrapper>
      )
    } else {
      return (<InputElement {...otherProps} onChange={this.onFormElementChange} />)
    }
  }
}

const InputElement = props => <textarea {...props} autoFocus={props.autoFocus} className='text-area' />

InputElement.propTypes = {
  autoFocus: PropTypes.bool
}

TextArea.defaultProps = {autoFocus: false, wrap: true}
